<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdPelletizingIngredientPlanResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button
                                            type="gotoChild"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="查看详情"
                                            @click="gotoChildPage(customRowScope.row)">
                                        </em-button>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-icon="fa fa-clone"
                                            custom-label="复制计划"
                                            @click="$refs.copyPlan.showModal(customRowScope.row)"
                                        ></em-button>
                                        <em-button
                                            type="search"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-icon="fa fa-thumb-tack"
                                            custom-label="保存计划"
                                            confirm-text="是否确认保存，保存后将不能编辑"
                                            @click="freezePlan(customRowScope.row)"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <re-b-modal ref="copyPlan" header="复制计划"
                    @ok="submitCopy"
                    @dataSet="row=>this.beginTime=row.beginTime">
            <diverse-input :value.sync="beginTime" type="date">开始时间</diverse-input>
        </re-b-modal>
    </div>
</template>
<script>
// Author Liang Gang Qiang
// Date 2021-10-21 14:12:57

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput";

export default {
    name: "mintalMesPrdPelletizingIngredientPlanListView",
    components: {DiverseInput, ReBModal},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            beginTime: null
        }
    },
    methods: {
        gotoChildPage(row) {
            this.$_emGotoMixin_gotoHolderList("mintalMesPrdPelletizingIngredientPlanItem"
                , {ingredientPlanIdFilter: row.id, ingredientCodeFilter: row.code}
                , {ingredientPlanId: row.id, ingredientCode: row.code}, false, {});
        },
        submitCopy() {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_PRD_URL + "/mintalMesPrdPelletizingIngredientPlan/copy",
                data: {
                    id: this.$refs.copyPlan.getTempObject().id,
                    beginTime: this.beginTime
                }
            }).then(() => {
                this.$message.success("Operation success");
                this.$refs.emListFilter.doQuery();
            })
        },
        freezePlan(row) {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_MINTALMES_PRD_URL + "/mintalMesPrdPelletizingIngredientPlan/freeze?planId=" + row.id
            }).then(() => {
                this.$message.success("Operation success");
                this.$refs.emListFilter.doQuery();
            })
        }
    }
};
</script>